import * as actionTypes from "./actionTypes";

const initialState = {
  networkName: "",
  networkMission: "",
  networkRegion: "",
  environmentName: "",
  deployOption: "",
  provider: "",
  algorithm: "",
  envValue: "",
  accountType: "",
  nameofNode: "",
  membership: "",
  nodeofRegion: "",
  sizeOfNode: "",
  informationOfNode: [],
  addNetwork: null,
  addNetworkLoading: false,
  getNode: null,
  getNodeLoading: false,
  isChainLoading: false,
  downloadFile: null,
  getNewMnemonics: "",
  isChain: "",
  networkSummaryAiData: null,
  fullNetworkSummaryAiData: null,
};

const nodeReducer = (state = initialState, action) => {
  switch (action.type) {
    //   NETWORK
    case actionTypes.GET_NETWORK_SUMMERY: {
      return {
        ...state,
        networkName: action.payload.networkName,
        networkMission: action.payload.networkStatement,
      };
    }

    case actionTypes.SET_NETWORK_SUMMARY_AI: {
      return {
        ...state,
        networkSummaryAiData: action.payload,
      };
    }
    case actionTypes.GET_MNEMONICS: {
      return {
        ...state,
        getNewMnemonics: action.payload,
      };
    }
    case actionTypes.GET_NETWORK_REGION: {
      return {
        ...state,
        networkRegion: action.payload,
      };
    }

    case actionTypes.CHAIN_LOADING: {
      return {
        ...state,
        isChainLoading: action.payload,
      };
    }

    // ENVIRONMENT
    case actionTypes.GET_ENVIRONMENT_SUMMERY: {
      return {
        ...state,
        environmentName: action.payload.name,
        deployOption: action.payload.option,
      };
    }
    case actionTypes.GET_ENVIRONMENT_CONFIG: {
      return {
        ...state,
        provider: action.payload.Provider,
        algorithm: action.payload.Algorithm,
        envValue: action.payload.value,
        accountType: action.payload.accountType,
      };
    }
    // NODE
    case actionTypes.GET_NODE_SUMMERY: {
      return {
        ...state,
        nameofNode: action.payload.newName,
        membership: action.payload.membership,
        nodeofRegion: action.payload.selectRegion,
      };
    }
    case actionTypes.GET_NODE_SETTING: {
      return {
        ...state,
        sizeOfNode: action.payload,
      };
    }

    case actionTypes.SEND_NODE_INFORMATION: {
      return {
        ...state,
        informationOfNode: [...state.informationOfNode, action.payload],
      };
    }

    case actionTypes.SET_ADD_NETWORK_LOADING:
      return { ...state, addNetworkLoading: action.payload };
    case actionTypes.SET_ADD_NETWORK: {
      return {
        ...state,
        addNetwork: action.payload,
      };
    }

    case actionTypes.IS_CHAIN: {
      return {
        ...state,
        isChain: action.payload,
      };
    }

    case actionTypes.SET_NODE_LOADING:
      return { ...state, getNodeLoading: action.payload };
    case actionTypes.SET_NODE: {
      return {
        ...state,
        getNode: action.payload,
      };
    }

    case actionTypes.SET_AI_DATA: {
      const { config } = action.payload || {};

      return {
        ...state,
        // 1. Full AI Data store karein (optional, agar future mein chahiye ho)
        fullNetworkSummaryAiData: action.payload || null,

        // 2. config.accountName ko networkName mein set karein
        networkName: config?.accountName || state.networkName,

        provider: config?.platform || state.provider,

        // 3. ChainId aur CoinName ko envValue object mein set karein
        envValue:
          {
            ...state.envValue,
            idvalue: config?.chainId || "",
            coinName: config?.coinName || "",

            // New Requirement: Mapping balance and stakeAmount inside inputFields[0]
            inputFields: [
              {
                // Preserving existing fields (like mnemonics/accountName) if they exist in state
                ...(state.envValue?.inputFields?.[0] || {}),

                supplyChain: config?.balance, // Set balance to supplyChain
                amount: config?.stakeAmount, // Set stakeAmount to amount
              },
            ],
          } || "",
      };
    }

    case actionTypes.DOWNLOAD_FILE: {
      return {
        ...state,
        downloadFile: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

export default nodeReducer;
